import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Skeleton, Stack, TextInput } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { Add, CloseOutlined, SearchOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useContext, useState } from "react";
import { useCreateLocationMutation, useDeleteLocationMutation, useGetLocationsQuery, useUpdateLocationMutation } from "../../graphql/graphql";
import { LocationEmptyState } from "../location/LocationEmptyState";
import { showSuccessNotification } from "../../shared/Notifications";
import { AppContext } from "../../shared/PrivateRoutes";
import { LocationCard } from "../location/LocationCard";
export const SettingsLocationsTab = ({ opened }) => {
    // Context
    const { organizationId } = useContext(AppContext);
    // State
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebouncedValue(search, 300);
    const [creatingNew, setCreatingNew] = useState(false);
    // Queries
    const [{ data, fetching }] = useGetLocationsQuery({
        requestPolicy: "cache-and-network",
        variables: { search: debouncedSearch },
        pause: !opened
    });
    const locations = data?.locations?.locations ?? [];
    // Mutations
    const [, updateLocation] = useUpdateLocationMutation();
    const [, deleteLocation] = useDeleteLocationMutation();
    const [, createLocation] = useCreateLocationMutation();
    if (!organizationId || !opened)
        return null;
    return (_jsxs(Stack, { gap: "sm", children: [_jsxs(Flex, { justify: "space-between", align: "center", children: [_jsx(TextInput, { placeholder: "Search locations...", leftSection: _jsx(SvgIcon, { component: SearchOutlined }), value: search, onChange: (e) => setSearch(e.currentTarget.value), rightSection: search ? (_jsx(SvgIcon, { component: CloseOutlined, sx: {
                                width: "0.9rem",
                                height: "0.9rem",
                                cursor: "pointer"
                            }, onClick: () => setSearch("") })) : null, style: { flex: 1 } }), _jsx(Button, { leftSection: _jsx(SvgIcon, { component: Add }), onClick: () => setCreatingNew(true), ml: "sm", disabled: creatingNew, children: "Add New" })] }), fetching && (_jsx(Stack, { gap: "sm", children: Array.from({ length: 3 }).map((_, i) => (_jsx(Skeleton, { height: 90, radius: "md" }, i))) })), creatingNew && (_jsx(LocationCard, { isNew: true, onSave: async (values) => {
                    await createLocation(values);
                    showSuccessNotification("Location created");
                    setCreatingNew(false);
                }, onCancel: () => setCreatingNew(false) })), !fetching && locations.length === 0 && !creatingNew && (_jsx(LocationEmptyState, { onAddLocation: () => setCreatingNew(true) })), !fetching &&
                locations.map((location) => (_jsx(LocationCard, { location: location, onSave: async (values) => {
                        await updateLocation({
                            locationId: location.locationId,
                            ...values
                        });
                        showSuccessNotification(`${values.name || location.name} updated`);
                    }, onDeactivate: async () => {
                        await updateLocation({
                            locationId: location.locationId,
                            isActive: !location.isActive
                        });
                        showSuccessNotification(`${location.name} ${location.isActive ? "deactivated" : "activated"}`);
                    }, onDelete: async () => {
                        await deleteLocation({
                            locationId: location.locationId
                        });
                        showSuccessNotification(`${location.name} was deleted`);
                    } }, location.locationId)))] }));
};
